import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=c29d0816&"
import script from "./EditEvent.vue?vue&type=script&lang=ts&"
export * from "./EditEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports